// services/rating.service.ts
import axiosInstance from "../axios.service"
import BaseUrl from "../url.service"

const serverUrl = `${BaseUrl}/webUserRating`

/**
 * ===============================
 * CUSTOMER
 * ===============================
 */

// Add rating (logged-in user)
export const addRatingApi = (formData) => {
  return axiosInstance.post(`${serverUrl}/add`, formData)
}

// Get approved ratings for a product
export const getProductRatingsApi = (productId) => {
  return axiosInstance.get(`${serverUrl}/get/${productId}`)
}

// Delete own rating
export const deleteRatingApi = (ratingId) => {
  return axiosInstance.delete(`${serverUrl}/${ratingId}`)
}

/**
 * ===============================
 * ADMIN
 * ===============================
 */

// Get all ratings (admin moderation)
export const getAllRatingsAdminApi = (query) => {
  return axiosInstance.get(`${serverUrl}/ratings${query ? `?${query}` : ""}`)
}

// Approve / Reject rating
export const updateRatingStatusApi = (ratingId, payload) => {
  return axiosInstance.patch(`${serverUrl}/${ratingId}/status`, payload)
}

/**
 * ===============================
 * VENDOR
 * ===============================
 */

// Get ratings for vendor products
export const getVendorRatingsApi = (query) => {
  return axiosInstance.get(
    `${serverUrl}/vendor/ratings${query ? `?${query}` : ""}`
  )
}

const RatingService = {
  addRating: addRatingApi,
  getProductRatings: getProductRatingsApi,
  deleteRating : deleteRatingApi,
  getAllRatingsAdmin: getAllRatingsAdminApi,
  updateRatingStatus: updateRatingStatusApi,
  getVendorRatings: getVendorRatingsApi
}

export default RatingService